import request from '@/utils/request'; // 服务名：ecargoprotocol

export var BASE = '/api';
export var BASE_PATH = '/ecargoprotocol'; // 协议列查询

export function getProtoList(query) {
  return request({
    url: '/ecargoprotocol/protocolQuery/findByConditions',
    method: 'post',
    data: query
  });
} // 协议清单导出

export function protocolInventoryDc(data) {
  return request({
    url: '/ecargoprotocol/protocolQuery/protocolInventoryDc',
    method: 'post',
    data: data,
    responseType: 'blob'
  });
}
export function countProtocolInventoryDc(data) {
  return request({
    url: '/ecargoprotocol/protocolQuery/countProtocolInventoryDc',
    method: 'post',
    data: data
  });
} // 协议保存

export function submitProtoInfo(data) {
  return request({
    url: '/ecargoprotocol/protocolInfo/protocolSubmit',
    method: 'post',
    data: data
  });
} // 默认必有条款 查询

export function findByBcCheckAddClause(data) {
  return request({
    url: '/ecargoprotocol/protocolInfo/findByBcCheckAddClause',
    method: 'post',
    data: data
  });
} // 查询平台必加条款

export function findMustClause(data) {
  return request({
    url: '/ecargoprotocol/protocolInfo/findMustClause',
    method: 'post',
    data: data
  });
} // 根据op协议号查询协议信息

export function findByNo(data) {
  return request({
    url: '/ecargoprotocol/protocolInfo/findByNo',
    method: 'post',
    data: data
  });
} // 查询核心协议

export function findProtoBaseInfo(data) {
  return request({
    url: '/ecargoprotocol/protocolInfo/findPrEndorseByNo',
    method: 'post',
    data: data
  });
} // 协议删除

export function deleteProto(data) {
  return request({
    url: '/ecargoprotocol/protocolInfo/protocolDelete',
    method: 'post',
    data: data
  });
} // 协议禁用

export function disableProto(data) {
  return request({
    url: '/ecargoprotocol/protocolInfo/protocolDisable',
    method: 'post',
    data: data
  });
} // 查询审核意见

export function queryAuditRecord(data) {
  return request({
    url: '/ecargopolicy/sysAuditrecord/queryAuditRecord',
    method: 'get',
    params: data
  });
} // 审核提交

export function auditProtocol(data) {
  return request({
    url: '/ecargoprotocol/protocolAudit/auditProtocol',
    method: 'post',
    data: data
  });
} // 协议占号与取消

export function seizedInfo(data) {
  return request({
    url: '/ecargoprotocol/protocolInfo/seizedInfoSaveAndRemove',
    method: 'post',
    data: data
  });
} // 查询产品(查产品名称)

export function getProductList(query) {
  return request({
    url: '/ecargopolicy/risk/queryAll',
    method: 'get',
    params: query
  });
} // 查询批改协议记录

export function findEndorseRecord(query) {
  return request({
    url: '/ecargoprotocol/protocolEndorse/findEndorseRecord',
    method: 'get',
    params: query
  });
}